


//import {typesSojourn} from '../types/sojournTypes'
import {typesSojourn} from './svtypes/sojournTypes'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../constants'
const _ = require('lodash')
const HBD_URL = 'http://photos.hotelbeds.com/giata/'
  
/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    fgtree :{
        "10": {
            "facilityGroupCodeName": "Location",
            "facilityGroupCode": 10,
            "facilities": [
                {
                    "id": 12,
                    "code": 100,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Suites"
                },
                {
                    "id": 30,
                    "code": 110,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Apartments"
                },
                {
                    "id": 53,
                    "code": 124,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Disability-friendly rooms"
                },
                {
                    "id": 109,
                    "code": 20,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of construction"
                },
                {
                    "id": 224,
                    "code": 30,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Year of most recent renovation"
                },
                {
                    "id": 315,
                    "code": 40,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Annexe (s)"
                },
                {
                    "id": 358,
                    "code": 50,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (main building)"
                },
                {
                    "id": 447,
                    "code": 60,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Number of floors (annexe)"
                },
                {
                    "id": 493,
                    "code": 70,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 20,
                    "description": "Total number of rooms"
                },
                {
                    "id": 533,
                    "code": 80,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Single rooms"
                },
                {
                    "id": 576,
                    "code": 90,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Double rooms"
                },
                {
                    "id": 589,
                    "code": 95,
                    "facilityGroupCode": 10,
                    "facilityTypologyCode": 2,
                    "description": "Junior suites"
                }
            ]
        }
    },
     //sjjul3 commented
   // my_data: [],
    svr_soj_detail_images_ob:{
        "images":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj7.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj8.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj9.jpg`],
        "gallery":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`, `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj6.jpg` ],
        "arcade":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`,`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`],
        "face":[`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`]
    
    },
    
    sojourns:[{
        "resortcode": "253",
        "languagecode": "EN",
        "region_id": "3.824,13824",
        "legacyregion_code": "ECSO",
        "regionid_xml_id_list": [
            13,
            45,
            23
        ],
        "region_hierarchy": [
            "US",
            "NY",
            "albany"
        ],
        "subregion_info": [
            "10BM",
            "BCAG",
            "DEER"
        ],
        "nearest_airports": "Del Aiport",
        "nearest_airport_distance_km": 12,
        "nearest_airport_distance_mi": 8,
        "all_inclusive": "N",
        "vep_rating": 1,
        "amenity_name": [
            "HotTub",
            "Spa",
            "Swimming pool",
            "Laundry"
        ],
        "amenity_distance_km_list": [
            13,
            45,
            23
        ],
        "amenity_distance_mi_list": [
            13,
            45,
            23
        ],
        "amenity_xml_id_list": [
            1339513,
            4531114
        ],
        "activity_name": [
            "Swimming Beach",
            "Tennis, Water"
        ],
        "activity_distance_km_list": [
            13,
            45,
            23
        ],
        "activity_distance_mi_list": [
            7,
            9,
            10
        ],
        "activity_xml_id_list": [
            13,
            45,
            23
        ],
        "avg_rating_list": [
            "MR_BP_4.0",
            "MR_DN_4.0"
        ],
        "num_reviews": 101,
        "resort_name": "253 Mancreek Resort",
        "address_line1": " 253 scottland av",
        "county": "albanyt",
        "postalcode": 12193,
        "market_code": "NAMER",
        "country": "usa",
        "region_desc_en": [
            "United States",
            "Coastal Mid Atlantic"
        ],
        "state": "NY",
        "location": {
            "lat": 33.6241,
            "lon": -78.9675
        },
        "destination": "Myrtle Beach",
        "address_line2": "albany city",
        "vacation_type": "albany city",
        "vacation_type_xml_id_list": [
            1339513,
            4531114
        ],
        "media_type": "photos",
        "highlights": "The ideal vacation escape",
        "directions": "The ideal vacation escape, Deercreek is just a mile from the beach.",
        "urgent_info": "One in X Rule Applies",
        "additional_info": "Eachu unit is air-conditioned.",
        "city_name": "albany"
    }],
    //sjjul3 start
    my_esqueryText : "mexco",
    sv_esquery_data : {
        my_esqueryText: "xx",
        STARTDATE:"2023-10-24",
        ENDDATE: "2023-11-27" , 
        time_zone: "+01:00"

      },
    hasMore:true,
    ctotal:3,
    my_scr_id:"AAluY2x1ZGVfY29udGV4dF91dWlkDXF1ZXJ5QW5kRmV0Y2gBFkpsWjEtSjJpU0VlUnFWRFRUcDZrMlEAAAAAAAATQRZqU0xtQ3VBQ1NPZWNXbGI5NEx6TVdR",
    my_data: [{
        "sojourncode": "200",
        "vernacularcode": "EN",
        "sojourn_name": "200 Mary Resort",
         "hotel": {
            "code": 1130,
            "name": {
                "content": "Parque de la Paz"
            },
            "description": {
                "content": "This aparthotel is situated within walking distance, about 800 metres, from the closest local beach, known as Las Vistas and it is conveniently located approximately 100 m from the nearest shopping venues, restaurants and bars. Guests will find the nearest public bus stop at around 100 m from the hotel. This is a perfect place for families with children that wish to spend a nice holiday by the sea."
            },
            "countryCode": "ES",
            "stateCode": "38",
            "destinationCode": "TFS",
            "zoneCode": 80,
            "coordinates": {
                "longitude": -16.729314,
                "latitude": 28.055675
            },
            "categoryCode": "APTH4",
            "categoryGroupCode": "GRUPO7",
            "accommodationTypeCode": "P",
            "boardCodes": [
                "SC",
                "BB",
                "AI",
                "HB",
                "RO"
            ],
            "segmentCodes": [
                81,
                37,
                102
            ],
            "address": {
                "content": "Calle Luis Diaz De Losada, 2",
                "street": "Calle Luis Diaz De Losada",
                "number": "2"
            },
            "postalCode": "38660",
            "city": {
                "content": "PLAYA DE LAS AMERICAS"
            },
            "email": "parquelapaz@parquelapaz.com",
            "giataCode": 6883,
            "phones": [
                {
                    "phoneNumber": "+922795061",
                    "phoneType": "PHONEBOOKING"
                },
                {
                    "phoneNumber": "+34922795061",
                    "phoneType": "PHONEHOTEL"
                },
                {
                    "phoneNumber": "922795309",
                    "phoneType": "PHONEMANAGEMENT"
                },
                {
                    "phoneNumber": "+922795259",
                    "phoneType": "FAXNUMBER"
                }
            ],
            "rooms": [
                {
                    "roomCode": "APT.B1-1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-5",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-6",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-7",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-8",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-8",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-9",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-9"
                },
                {
                    "roomCode": "APT.B1-C1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C1"
                },
                {
                    "roomCode": "APT.B1-C2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C2"
                },
                {
                    "roomCode": "APT.B1-C3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C3"
                },
                {
                    "roomCode": "APT.B1-C4",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B1-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-DX"
                },
                {
                    "roomCode": "APT.B1-TR",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-TR"
                },
                {
                    "roomCode": "APT.B1-VP",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B1-VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B1-VP"
                },
                {
                    "roomCode": "APT.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 0,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 150,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "roomCode": "APT.B2-1",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 2,
                    "maxAdults": 2,
                    "maxChildren": 0,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B2-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 79,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APTO"
                },
                {
                    "roomCode": "APT.B2-2",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1"
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 4
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-3",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 4,
                    "maxChildren": 1,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-4",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-5",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 0,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "B2-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-6",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 5,
                    "maxChildren": 1,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-C4",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-C5",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-C5"
                },
                {
                    "roomCode": "APT.B2-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-DX"
                },
                {
                    "roomCode": "APT.B2-VP",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 4,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B2-VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 79,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 4
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B2-VP"
                },
                {
                    "roomCode": "APT.B2-WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-WV"
                },
                {
                    "roomCode": "APT.BL-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "BL-DX"
                },
                {
                    "roomCode": "APT.C4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C4"
                },
                {
                    "roomCode": "APT.C5",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 4,
                    "maxChildren": 1,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C5-1",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 0,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "C5-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C5-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C5-2"
                },
                {
                    "roomCode": "APT.C6",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 0,
                    "minAdults": 6,
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-1",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-2",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 5,
                    "maxChildren": 1,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "C6-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-3",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 0,
                    "minAdults": 6,
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C6-4"
                },
                {
                    "roomCode": "APT.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "APT.DX-10",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX-10"
                },
                {
                    "roomCode": "APT.DX-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX-VP"
                },
                {
                    "roomCode": "APT.LX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "LX"
                },
                {
                    "roomCode": "APT.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "APT.SU",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "SU"
                },
                {
                    "roomCode": "APT.VP",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B1-VP"
                },
                {
                    "roomCode": "APT.VP-1",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 2,
                    "maxAdults": 2,
                    "maxChildren": 0,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-2",
                    "isParentRoom": false,
                    "minPax": 3,
                    "maxPax": 3,
                    "maxAdults": 2,
                    "maxChildren": 1,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-3",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 2,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-4",
                    "isParentRoom": false,
                    "minPax": 3,
                    "maxPax": 3,
                    "maxAdults": 3,
                    "maxChildren": 0,
                    "minAdults": 3,
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-5",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 3,
                    "maxChildren": 1,
                    "minAdults": 3,
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "WV"
                },
                {
                    "roomCode": "APT.B1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room"
                        },
                        {
                            "stayType": "LIV",
                            "order": "1"
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.CV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "CV"
                },
                {
                    "roomCode": "APT.CV-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "CV-DX"
                },
                {
                    "roomCode": "BED.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "BED",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "FAM.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2"
                },
                {
                    "roomCode": "FAM.B2-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2-DX"
                },
                {
                    "roomCode": "FAM.B2-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2-VP"
                },
                {
                    "roomCode": "FAM.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "FAM.VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "VP"
                },
                {
                    "roomCode": "ROO.B1-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "B1-VP"
                },
                {
                    "roomCode": "ROO.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "B2"
                },
                {
                    "roomCode": "ROO.B2-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 0,
                    "roomType": "ROO",
                    "characteristicCode": "B2-VP"
                },
                {
                    "roomCode": "ROO.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "ROO.DX-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "DX-VP"
                },
                {
                    "roomCode": "ROO.LX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "LX"
                },
                {
                    "roomCode": "ROO.RO",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "RO"
                },
                {
                    "roomCode": "ROO.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "ROO.VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "VP"
                },
                {
                    "roomCode": "ROO.WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "WV"
                },
                {
                    "roomCode": "ROO.CV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "CV"
                },
                {
                    "roomCode": "STU.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 3,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "STU.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 3,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "STU.ST-1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                },
                {
                    "roomCode": "STU.ST-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                },
                {
                    "roomCode": "STU.ST-3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                }
            ],
            "terminals": [
                {
                    "terminalCode": "TFS",
                    "distance": 19
                }
            ],
            "interestPoints": [
                {
                    "facilityCode": 20,
                    "facilityGroupCode": 100,
                    "order": 1,
                    "poiName": "Water and themepark “Siam Park”",
                    "distance": "2500"
                },
                {
                    "facilityCode": 10,
                    "facilityGroupCode": 100,
                    "order": 1,
                    "poiName": "Water and themepark “Octopus-Aqualand”",
                    "distance": "3000"
                }
            ],
            "images": [
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_096.jpg",
                    "roomCode": "APT.B2-2",
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "order": 96,
                    "visualOrder": 334
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_097.jpg",
                    "roomCode": "APT.B2-2",
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "order": 97,
                    "visualOrder": 334
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_169.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 169,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_168.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 168,
                    "visualOrder": 400
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_032.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 32,
                    "visualOrder": 305
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_031.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 31,
                    "visualOrder": 305
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_159.jpg",
                    "roomCode": "APT.VP-3",
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "order": 159,
                    "visualOrder": 393
                },
                {
                    "imageTypeCode": "DEP",
                    "path": "00/001130/001130a_hb_f_002.jpg",
                    "order": 2,
                    "visualOrder": 802
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_117.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 117,
                    "visualOrder": 351
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_059.jpg",
                    "roomCode": "APT.B1-3",
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "order": 59,
                    "visualOrder": 311
                },
                {
                    "imageTypeCode": "DEP",
                    "path": "00/001130/001130a_hb_f_001.jpg",
                    "order": 1,
                    "visualOrder": 801
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_001.jpg",
                    "order": 1,
                    "visualOrder": 103
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_042.jpg",
                    "roomCode": "APT.B1-6",
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "order": 42,
                    "visualOrder": 319
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_003.jpg",
                    "order": 3,
                    "visualOrder": 103
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_064.jpg",
                    "roomCode": "APT.B1-8",
                    "roomType": "APT",
                    "characteristicCode": "B1-8",
                    "order": 64,
                    "visualOrder": 323
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_148.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 148,
                    "visualOrder": 383
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_002.jpg",
                    "order": 2,
                    "visualOrder": 101
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_149.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 149,
                    "visualOrder": 384
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_115.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 115,
                    "visualOrder": 349
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_116.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 116,
                    "visualOrder": 350
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_002.jpg",
                    "order": 2,
                    "visualOrder": 401
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_113.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 113,
                    "visualOrder": 348
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_158.jpg",
                    "roomCode": "APT.VP-3",
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "order": 158,
                    "visualOrder": 392
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_001.jpg",
                    "order": 1,
                    "visualOrder": 602
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_001.jpg",
                    "order": 1,
                    "visualOrder": 405
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_114.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 114,
                    "visualOrder": 349
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_002.jpg",
                    "order": 2,
                    "visualOrder": 603
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_030.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 30,
                    "visualOrder": 304
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_003.jpg",
                    "order": 3,
                    "visualOrder": 601
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_065.jpg",
                    "roomCode": "APT.B1",
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "order": 66,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_004.jpg",
                    "order": 4,
                    "visualOrder": 102
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_080.jpg",
                    "roomCode": "STU.ST-3",
                    "roomType": "STU",
                    "characteristicCode": "ST-3",
                    "order": 80,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_004.jpg",
                    "order": 4,
                    "visualOrder": 403
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_003.jpg",
                    "order": 3,
                    "visualOrder": 402
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_006.jpg",
                    "order": 6,
                    "visualOrder": 404
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_005.jpg",
                    "order": 5,
                    "visualOrder": 404
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_008.jpg",
                    "order": 8,
                    "visualOrder": 407
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_007.jpg",
                    "order": 7,
                    "visualOrder": 406
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_038.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 38,
                    "visualOrder": 313
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_072.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 72,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_073.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 73,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_170.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 170,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_071.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 71,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_150.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 150,
                    "visualOrder": 385
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_151.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 151,
                    "visualOrder": 385
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_152.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 152,
                    "visualOrder": 386
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_172.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 172,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_171.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 171,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_129.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 129,
                    "visualOrder": 364
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_134.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 134,
                    "visualOrder": 368
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_135.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 135,
                    "visualOrder": 369
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_136.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 136,
                    "visualOrder": 370
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_128.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 128,
                    "visualOrder": 364
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_137.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 137,
                    "visualOrder": 371
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_120.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 120,
                    "visualOrder": 356
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_143.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 143,
                    "visualOrder": 376
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_121.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 121,
                    "visualOrder": 357
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_144.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 144,
                    "visualOrder": 376
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_122.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 122,
                    "visualOrder": 358
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_145.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 145,
                    "visualOrder": 377
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_133.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 133,
                    "visualOrder": 367
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_146.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 146,
                    "visualOrder": 377
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_147.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 147,
                    "visualOrder": 378
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_033.jpg",
                    "roomCode": "APT.B1",
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "order": 33,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_070.jpg",
                    "roomCode": "APT.B1-3",
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "order": 70,
                    "visualOrder": 312
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_062.jpg",
                    "roomCode": "APT.B1-6",
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "order": 62,
                    "visualOrder": 320
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_041.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 41,
                    "visualOrder": 314
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_132.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 132,
                    "visualOrder": 367
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_130.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 130,
                    "visualOrder": 365
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_131.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 131,
                    "visualOrder": 366
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_108.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 108,
                    "visualOrder": 344
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_118.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 118,
                    "visualOrder": 354
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_109.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 109,
                    "visualOrder": 345
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_119.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 119,
                    "visualOrder": 355
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_036.jpg",
                    "roomCode": "APT.B1-2",
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "order": 36,
                    "visualOrder": 307
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_038.jpg",
                    "roomCode": "APT.B1-2",
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "order": 38,
                    "visualOrder": 308
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_043.jpg",
                    "roomCode": "APT.B1-7",
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "order": 43,
                    "visualOrder": 321
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_040.jpg",
                    "roomCode": "APT.B1-7",
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "order": 40,
                    "visualOrder": 321
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_110.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 110,
                    "visualOrder": 346
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_111.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 111,
                    "visualOrder": 346
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_112.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 112,
                    "visualOrder": 347
                },
                {
                    "imageTypeCode": "RES",
                    "path": "00/001130/001130a_hb_r_001.jpg",
                    "order": 1,
                    "visualOrder": 501
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_154.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 154,
                    "visualOrder": 388
                },
                {
                    "imageTypeCode": "RES",
                    "path": "00/001130/001130a_hb_r_002.jpg",
                    "order": 2,
                    "visualOrder": 502
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_155.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 155,
                    "visualOrder": 389
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_153.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 153,
                    "visualOrder": 387
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_156.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 156,
                    "visualOrder": 390
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_157.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 157,
                    "visualOrder": 391
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_167.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 167,
                    "visualOrder": 399
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_166.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 166,
                    "visualOrder": 398
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_165.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 165,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_164.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 164,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_163.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 163,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_060.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 60,
                    "visualOrder": 315
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_077.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 77,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_075.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 75,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_076.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 76,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_093.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 93,
                    "visualOrder": 323
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_094.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 94,
                    "visualOrder": 324
                },
                {
                    "imageTypeCode": "TER",
                    "path": "00/001130/001130a_hb_t_001.jpg",
                    "order": 1,
                    "visualOrder": 901
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_095.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 95,
                    "visualOrder": 325
                }
            ],
            "web": "www.parquelapaz.com",
            "lastUpdate": "2024-07-09",
            "S2C": "4*",
            "ranking": 26
        }
    },
    {
        "sojourncode": "201",
        "vernacularcode": "EN",
        "sojourn_name": "201 John Resort",
        "hotel":{
            "code": 1130,
            "name": {
                "content": "Parque de la Paz"
            },
            "description": {
                "content": "This aparthotel is situated within walking distance, about 800 metres, from the closest local beach, known as Las Vistas and it is conveniently located approximately 100 m from the nearest shopping venues, restaurants and bars. Guests will find the nearest public bus stop at around 100 m from the hotel. This is a perfect place for families with children that wish to spend a nice holiday by the sea."
            },
            "countryCode": "ES",
            "stateCode": "38",
            "destinationCode": "TFS",
            "zoneCode": 80,
            "coordinates": {
                "longitude": -16.729314,
                "latitude": 28.055675
            },
            "categoryCode": "APTH4",
            "categoryGroupCode": "GRUPO7",
            "accommodationTypeCode": "P",
            "boardCodes": [
                "SC",
                "BB",
                "AI",
                "HB",
                "RO"
            ],
            "segmentCodes": [
                81,
                37,
                102
            ],
            "address": {
                "content": "Calle Luis Diaz De Losada, 2",
                "street": "Calle Luis Diaz De Losada",
                "number": "2"
            },
            "postalCode": "38660",
            "city": {
                "content": "PLAYA DE LAS AMERICAS"
            },
            "email": "parquelapaz@parquelapaz.com",
            "giataCode": 6883,
            "phones": [
                {
                    "phoneNumber": "+922795061",
                    "phoneType": "PHONEBOOKING"
                },
                {
                    "phoneNumber": "+34922795061",
                    "phoneType": "PHONEHOTEL"
                },
                {
                    "phoneNumber": "922795309",
                    "phoneType": "PHONEMANAGEMENT"
                },
                {
                    "phoneNumber": "+922795259",
                    "phoneType": "FAXNUMBER"
                }
            ],
            "rooms": [
                {
                    "roomCode": "APT.B1-1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-5",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-6",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-7",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-8",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-8",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APT"
                },
                {
                    "roomCode": "APT.B1-9",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-9"
                },
                {
                    "roomCode": "APT.B1-C1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C1"
                },
                {
                    "roomCode": "APT.B1-C2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C2"
                },
                {
                    "roomCode": "APT.B1-C3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-C3"
                },
                {
                    "roomCode": "APT.B1-C4",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B1-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-DX"
                },
                {
                    "roomCode": "APT.B1-TR",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1-TR"
                },
                {
                    "roomCode": "APT.B1-VP",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B1-VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B1-VP"
                },
                {
                    "roomCode": "APT.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 0,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 150,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ]
                },
                {
                    "roomCode": "APT.B2-1",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 2,
                    "maxAdults": 2,
                    "maxChildren": 0,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B2-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 79,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "APTO"
                },
                {
                    "roomCode": "APT.B2-2",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1"
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 4
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-3",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 4,
                    "maxChildren": 1,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-4",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-5",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 0,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "B2-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-6",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 5,
                    "maxChildren": 1,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-C4",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 0,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.B2-C5",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-C5"
                },
                {
                    "roomCode": "APT.B2-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-DX"
                },
                {
                    "roomCode": "APT.B2-VP",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 4,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "B2-VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 79,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 4
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B2-VP"
                },
                {
                    "roomCode": "APT.B2-WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B2-WV"
                },
                {
                    "roomCode": "APT.BL-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "BL-DX"
                },
                {
                    "roomCode": "APT.C4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C4"
                },
                {
                    "roomCode": "APT.C5",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 4,
                    "maxChildren": 1,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C5-1",
                    "isParentRoom": false,
                    "minPax": 5,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 0,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "C5-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C5-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C5-2"
                },
                {
                    "roomCode": "APT.C6",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 0,
                    "minAdults": 6,
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-1",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 4,
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-2",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 5,
                    "maxChildren": 1,
                    "minAdults": 5,
                    "roomType": "APT",
                    "characteristicCode": "C6-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 2,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "BED",
                            "order": "2",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-3",
                    "isParentRoom": false,
                    "minPax": 6,
                    "maxPax": 6,
                    "maxAdults": 6,
                    "maxChildren": 0,
                    "minAdults": 6,
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 45,
                            "indYesOrNo": true,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.C6-4",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "C6-4"
                },
                {
                    "roomCode": "APT.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "APT.DX-10",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX-10"
                },
                {
                    "roomCode": "APT.DX-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "DX-VP"
                },
                {
                    "roomCode": "APT.LX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "LX"
                },
                {
                    "roomCode": "APT.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "APT.SU",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "SU"
                },
                {
                    "roomCode": "APT.VP",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 57,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "B1-VP"
                },
                {
                    "roomCode": "APT.VP-1",
                    "isParentRoom": false,
                    "minPax": 2,
                    "maxPax": 2,
                    "maxAdults": 2,
                    "maxChildren": 0,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-2",
                    "isParentRoom": false,
                    "minPax": 3,
                    "maxPax": 3,
                    "maxAdults": 2,
                    "maxChildren": 1,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-3",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 2,
                    "maxChildren": 2,
                    "minAdults": 2,
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-4",
                    "isParentRoom": false,
                    "minPax": 3,
                    "maxPax": 3,
                    "maxAdults": 3,
                    "maxChildren": 0,
                    "minAdults": 3,
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.VP-5",
                    "isParentRoom": false,
                    "minPax": 4,
                    "maxPax": 4,
                    "maxAdults": 3,
                    "maxChildren": 1,
                    "minAdults": 3,
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "roomFacilities": [
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        },
                        {
                            "stayType": "LIV",
                            "order": "1",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 284,
                                    "facilityGroupCode": 61,
                                    "number": 1
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "WV"
                },
                {
                    "roomCode": "APT.B1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 4,
                    "maxAdults": 4,
                    "maxChildren": 2,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 220,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 38,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room"
                        },
                        {
                            "stayType": "LIV",
                            "order": "1"
                        }
                    ],
                    "PMSRoomCode": "N/A"
                },
                {
                    "roomCode": "APT.CV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "CV"
                },
                {
                    "roomCode": "APT.CV-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "APT",
                    "characteristicCode": "CV-DX"
                },
                {
                    "roomCode": "BED.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "BED",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "FAM.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2"
                },
                {
                    "roomCode": "FAM.B2-DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2-DX"
                },
                {
                    "roomCode": "FAM.B2-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "B2-VP"
                },
                {
                    "roomCode": "FAM.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "FAM.VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 8,
                    "maxAdults": 8,
                    "maxChildren": 4,
                    "minAdults": 1,
                    "roomType": "FAM",
                    "characteristicCode": "VP"
                },
                {
                    "roomCode": "ROO.B1-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "B1-VP"
                },
                {
                    "roomCode": "ROO.B2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "B2"
                },
                {
                    "roomCode": "ROO.B2-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 0,
                    "roomType": "ROO",
                    "characteristicCode": "B2-VP"
                },
                {
                    "roomCode": "ROO.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "ROO.DX-VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "DX-VP"
                },
                {
                    "roomCode": "ROO.LX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "LX"
                },
                {
                    "roomCode": "ROO.RO",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "RO"
                },
                {
                    "roomCode": "ROO.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "ROO.VP",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "VP"
                },
                {
                    "roomCode": "ROO.WV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "WV"
                },
                {
                    "roomCode": "ROO.CV",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 10,
                    "maxAdults": 10,
                    "maxChildren": 6,
                    "minAdults": 1,
                    "roomType": "ROO",
                    "characteristicCode": "CV"
                },
                {
                    "roomCode": "STU.DX",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 3,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "DX"
                },
                {
                    "roomCode": "STU.ST",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 5,
                    "maxAdults": 5,
                    "maxChildren": 3,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST"
                },
                {
                    "roomCode": "STU.ST-1",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                },
                {
                    "roomCode": "STU.ST-2",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                },
                {
                    "roomCode": "STU.ST-3",
                    "isParentRoom": false,
                    "minPax": 1,
                    "maxPax": 1,
                    "maxAdults": 1,
                    "maxChildren": 0,
                    "minAdults": 1,
                    "roomType": "STU",
                    "characteristicCode": "ST-3",
                    "roomFacilities": [
                        {
                            "facilityCode": 10,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 20,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 30,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 40,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 50,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 55,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 100,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 111,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 115,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 130,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 137,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 143,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 200,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 230,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 240,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 260,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 261,
                            "facilityGroupCode": 60,
                            "indFee": false,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 262,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 264,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 268,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 272,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 275,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 286,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 288,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 289,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 295,
                            "facilityGroupCode": 60,
                            "number": 49,
                            "indYesOrNo": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 297,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 298,
                            "facilityGroupCode": 60,
                            "indLogic": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 300,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "indFee": false,
                            "voucher": false
                        },
                        {
                            "facilityCode": 318,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 319,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        },
                        {
                            "facilityCode": 320,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "voucher": false
                        },
                        {
                            "facilityCode": 330,
                            "facilityGroupCode": 60,
                            "indLogic": true,
                            "number": 1,
                            "voucher": false
                        }
                    ],
                    "roomStays": [
                        {
                            "stayType": "BED",
                            "order": "1",
                            "description": "Bed room",
                            "roomStayFacilities": [
                                {
                                    "facilityCode": 1,
                                    "facilityGroupCode": 61,
                                    "number": 2
                                }
                            ]
                        }
                    ],
                    "PMSRoomCode": "STU"
                }
            ],
            "terminals": [
                {
                    "terminalCode": "TFS",
                    "distance": 19
                }
            ],
            "interestPoints": [
                {
                    "facilityCode": 20,
                    "facilityGroupCode": 100,
                    "order": 1,
                    "poiName": "Water and themepark “Siam Park”",
                    "distance": "2500"
                },
                {
                    "facilityCode": 10,
                    "facilityGroupCode": 100,
                    "order": 1,
                    "poiName": "Water and themepark “Octopus-Aqualand”",
                    "distance": "3000"
                }
            ],
            "images": [
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_096.jpg",
                    "roomCode": "APT.B2-2",
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "order": 96,
                    "visualOrder": 334
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_097.jpg",
                    "roomCode": "APT.B2-2",
                    "roomType": "APT",
                    "characteristicCode": "B2-2",
                    "order": 97,
                    "visualOrder": 334
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_169.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 169,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_168.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 168,
                    "visualOrder": 400
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_032.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 32,
                    "visualOrder": 305
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_031.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 31,
                    "visualOrder": 305
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_159.jpg",
                    "roomCode": "APT.VP-3",
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "order": 159,
                    "visualOrder": 393
                },
                {
                    "imageTypeCode": "DEP",
                    "path": "00/001130/001130a_hb_f_002.jpg",
                    "order": 2,
                    "visualOrder": 802
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_117.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 117,
                    "visualOrder": 351
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_059.jpg",
                    "roomCode": "APT.B1-3",
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "order": 59,
                    "visualOrder": 311
                },
                {
                    "imageTypeCode": "DEP",
                    "path": "00/001130/001130a_hb_f_001.jpg",
                    "order": 1,
                    "visualOrder": 801
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_001.jpg",
                    "order": 1,
                    "visualOrder": 103
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_042.jpg",
                    "roomCode": "APT.B1-6",
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "order": 42,
                    "visualOrder": 319
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_003.jpg",
                    "order": 3,
                    "visualOrder": 103
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_064.jpg",
                    "roomCode": "APT.B1-8",
                    "roomType": "APT",
                    "characteristicCode": "B1-8",
                    "order": 64,
                    "visualOrder": 323
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_148.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 148,
                    "visualOrder": 383
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_002.jpg",
                    "order": 2,
                    "visualOrder": 101
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_149.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 149,
                    "visualOrder": 384
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_115.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 115,
                    "visualOrder": 349
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_116.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 116,
                    "visualOrder": 350
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_002.jpg",
                    "order": 2,
                    "visualOrder": 401
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_113.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 113,
                    "visualOrder": 348
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_158.jpg",
                    "roomCode": "APT.VP-3",
                    "roomType": "APT",
                    "characteristicCode": "VP-3",
                    "order": 158,
                    "visualOrder": 392
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_001.jpg",
                    "order": 1,
                    "visualOrder": 602
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_001.jpg",
                    "order": 1,
                    "visualOrder": 405
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_114.jpg",
                    "roomCode": "APT.B2-C4",
                    "roomType": "APT",
                    "characteristicCode": "B2-C4",
                    "order": 114,
                    "visualOrder": 349
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_002.jpg",
                    "order": 2,
                    "visualOrder": 603
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_030.jpg",
                    "roomCode": "APT.B1-1",
                    "roomType": "APT",
                    "characteristicCode": "B1-1",
                    "order": 30,
                    "visualOrder": 304
                },
                {
                    "imageTypeCode": "BAR",
                    "path": "00/001130/001130a_hb_ba_003.jpg",
                    "order": 3,
                    "visualOrder": 601
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_065.jpg",
                    "roomCode": "APT.B1",
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "order": 66,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "COM",
                    "path": "00/001130/001130a_hb_l_004.jpg",
                    "order": 4,
                    "visualOrder": 102
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_080.jpg",
                    "roomCode": "STU.ST-3",
                    "roomType": "STU",
                    "characteristicCode": "ST-3",
                    "order": 80,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_004.jpg",
                    "order": 4,
                    "visualOrder": 403
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_003.jpg",
                    "order": 3,
                    "visualOrder": 402
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_006.jpg",
                    "order": 6,
                    "visualOrder": 404
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_005.jpg",
                    "order": 5,
                    "visualOrder": 404
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_008.jpg",
                    "order": 8,
                    "visualOrder": 407
                },
                {
                    "imageTypeCode": "PIS",
                    "path": "00/001130/001130a_hb_p_007.jpg",
                    "order": 7,
                    "visualOrder": 406
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_038.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 38,
                    "visualOrder": 313
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_072.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 72,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_073.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 73,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_170.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 170,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_071.jpg",
                    "roomCode": "STU.ST-1",
                    "roomType": "STU",
                    "characteristicCode": "ST-1",
                    "order": 71,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_150.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 150,
                    "visualOrder": 385
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_151.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 151,
                    "visualOrder": 385
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_152.jpg",
                    "roomCode": "APT.VP-1",
                    "roomType": "APT",
                    "characteristicCode": "VP-1",
                    "order": 152,
                    "visualOrder": 386
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_172.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 172,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_171.jpg",
                    "roomCode": "APT.VP-5",
                    "roomType": "APT",
                    "characteristicCode": "VP-5",
                    "order": 171,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_129.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 129,
                    "visualOrder": 364
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_134.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 134,
                    "visualOrder": 368
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_135.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 135,
                    "visualOrder": 369
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_136.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 136,
                    "visualOrder": 370
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_128.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 128,
                    "visualOrder": 364
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_137.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 137,
                    "visualOrder": 371
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_120.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 120,
                    "visualOrder": 356
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_143.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 143,
                    "visualOrder": 376
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_121.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 121,
                    "visualOrder": 357
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_144.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 144,
                    "visualOrder": 376
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_122.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 122,
                    "visualOrder": 358
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_145.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 145,
                    "visualOrder": 377
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_133.jpg",
                    "roomCode": "APT.C6-1",
                    "roomType": "APT",
                    "characteristicCode": "C6-1",
                    "order": 133,
                    "visualOrder": 367
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_146.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 146,
                    "visualOrder": 377
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_147.jpg",
                    "roomCode": "APT.C6-3",
                    "roomType": "APT",
                    "characteristicCode": "C6-3",
                    "order": 147,
                    "visualOrder": 378
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_033.jpg",
                    "roomCode": "APT.B1",
                    "roomType": "APT",
                    "characteristicCode": "B1",
                    "order": 33,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_070.jpg",
                    "roomCode": "APT.B1-3",
                    "roomType": "APT",
                    "characteristicCode": "B1-3",
                    "order": 70,
                    "visualOrder": 312
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_062.jpg",
                    "roomCode": "APT.B1-6",
                    "roomType": "APT",
                    "characteristicCode": "B1-6",
                    "order": 62,
                    "visualOrder": 320
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_041.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 41,
                    "visualOrder": 314
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_132.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 132,
                    "visualOrder": 367
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_130.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 130,
                    "visualOrder": 365
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_131.jpg",
                    "roomCode": "APT.C6",
                    "roomType": "APT",
                    "characteristicCode": "C6",
                    "order": 131,
                    "visualOrder": 366
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_108.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 108,
                    "visualOrder": 344
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_118.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 118,
                    "visualOrder": 354
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_109.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 109,
                    "visualOrder": 345
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_119.jpg",
                    "roomCode": "APT.C5",
                    "roomType": "APT",
                    "characteristicCode": "C5",
                    "order": 119,
                    "visualOrder": 355
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_036.jpg",
                    "roomCode": "APT.B1-2",
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "order": 36,
                    "visualOrder": 307
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_038.jpg",
                    "roomCode": "APT.B1-2",
                    "roomType": "APT",
                    "characteristicCode": "B1-2",
                    "order": 38,
                    "visualOrder": 308
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_043.jpg",
                    "roomCode": "APT.B1-7",
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "order": 43,
                    "visualOrder": 321
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_040.jpg",
                    "roomCode": "APT.B1-7",
                    "roomType": "APT",
                    "characteristicCode": "B1-7",
                    "order": 40,
                    "visualOrder": 321
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_110.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 110,
                    "visualOrder": 346
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_111.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 111,
                    "visualOrder": 346
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_112.jpg",
                    "roomCode": "APT.B2-6",
                    "roomType": "APT",
                    "characteristicCode": "B2-6",
                    "order": 112,
                    "visualOrder": 347
                },
                {
                    "imageTypeCode": "RES",
                    "path": "00/001130/001130a_hb_r_001.jpg",
                    "order": 1,
                    "visualOrder": 501
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_154.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 154,
                    "visualOrder": 388
                },
                {
                    "imageTypeCode": "RES",
                    "path": "00/001130/001130a_hb_r_002.jpg",
                    "order": 2,
                    "visualOrder": 502
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_155.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 155,
                    "visualOrder": 389
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_153.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 153,
                    "visualOrder": 387
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_156.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 156,
                    "visualOrder": 390
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_157.jpg",
                    "roomCode": "APT.VP-2",
                    "roomType": "APT",
                    "characteristicCode": "VP-2",
                    "order": 157,
                    "visualOrder": 391
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_167.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 167,
                    "visualOrder": 399
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_166.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 166,
                    "visualOrder": 398
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_165.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 165,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_164.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 164,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_163.jpg",
                    "roomCode": "APT.VP-4",
                    "roomType": "APT",
                    "characteristicCode": "VP-4",
                    "order": 163,
                    "visualOrder": 397
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_060.jpg",
                    "roomCode": "APT.B1-4",
                    "roomType": "APT",
                    "characteristicCode": "B1-4",
                    "order": 60,
                    "visualOrder": 315
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_077.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 77,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_075.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 75,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_076.jpg",
                    "roomCode": "STU.ST-2",
                    "roomType": "STU",
                    "characteristicCode": "ST-2",
                    "order": 76,
                    "visualOrder": 301
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_093.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 93,
                    "visualOrder": 323
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_094.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 94,
                    "visualOrder": 324
                },
                {
                    "imageTypeCode": "TER",
                    "path": "00/001130/001130a_hb_t_001.jpg",
                    "order": 1,
                    "visualOrder": 901
                },
                {
                    "imageTypeCode": "HAB",
                    "path": "00/001130/001130a_hb_ro_095.jpg",
                    "roomCode": "APT.B1-C4",
                    "roomType": "APT",
                    "characteristicCode": "B1-C4",
                    "order": 95,
                    "visualOrder": 325
                }
            ],
            "web": "www.parquelapaz.com",
            "lastUpdate": "2024-07-09",
            "S2C": "4*",
            "ranking": 26
        }
    }],
    svr_soj_images : []
    
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
       
        case 'GET_SOJOURN_SUCCESS':
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data);
            // let januState = {...state, loading: false, my_data: action.payload.my_data}
             januState = {...state, loading: false, my_data: action.payload.my_data, svr_soj_detail_images_ob: action.payload.my_images}
            return januState
      
        case "GET_SOJ_PROD_AVL_HOTEL_SUCCESS":
                console.log("svoct17 SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
                console.log(action.payload);
                console.log("svoct17 end  SVESSearchRedicerreduce %%%%%%%%evsearcg  success*****************");
                let sj_scr_id=action.payload.my_scr_id ? action.payload.my_scr_id  : ''
                let fgtree = action.payload.fgtree ? action.payload.fgtree : {}
                let n_total = action.payload.my_data ? action.payload.my_data.length : 0
                let ps = state.ctotal
                let onddata_ar = action.payload.my_data.slice(0,1)

                let images =onddata_ar[0].hotel.images

               
                let im = null
                let ar_hib_images = []
                for(let i=0; i < images.length; i++){
                    im = HBD_URL + images[i].path 
                    ar_hib_images.push(im)

                }
                let svr_soj_detail_images_ob_tp = {
                    "images":ar_hib_images ? ar_hib_images.slice(0,9):[],
                    "gallery":ar_hib_images ? ar_hib_images.slice(0,6):[],
                    "arcade":ar_hib_images ? ar_hib_images.slice(0,2):[],
                    "face":ar_hib_images ? ar_hib_images.slice(0,1):[],
                
                }
                let sj_total = ps + n_total
                // let januState = {...state, loading: false, my_data: action.payload.my_data}
                if(action.payload.sv_esquery_data){
                   // januState = {...state, loading: false,  ctotal:sj_total,  my_scr_id:sj_scr_id, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images, sv_esquery_data: action.payload.sv_esquery_data}
                   januState = {...state,error: false, loading: false,  ctotal:sj_total, fgtree:fgtree,svr_soj_detail_images_ob:svr_soj_detail_images_ob_tp, my_scr_id:sj_scr_id, my_data: onddata_ar, svr_soj_images: action.payload.my_images, sv_esquery_data: action.payload.sv_esquery_data}
                
                }else{
                    januState = {...state, error: false,loading: false,  ctotal:sj_total,  fgtree:fgtree, svr_soj_detail_images_ob:svr_soj_detail_images_ob_tp, my_scr_id:sj_scr_id, my_data: onddata_ar, svr_soj_images: action.payload.my_images}
                   // januState = {...state, loading: false,  ctotal:sj_total, my_scr_id:sj_scr_id, my_data: action.payload.my_data, svr_soj_images: action.payload.my_images}
                
                }
                return januState
        case "GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR":
            console.log("error GET_SOJ_PROD_AVL_HOTEL_SERVER_ERROR or other ")
            return {...state,loading: false, hasMore:false, error: true}
                    
        case 'GET_SOJOURN_BEGIN':
            console.log("loading")
            return {...state, loading: true}
        case 'GET_SOJOURN_ERROR':
            console.log("error")
            return {...state, error: true}
        default:
            return state
    }
}